import { useState } from "react";
import { Bell, ChevronDown, CircleHelp, LogIn, LogOut, Menu, ShieldCheck, UserRound, X } from "lucide-react";

export function SiteBrand() {
  return <a className="brand" href="/" aria-label="Lupava.fi etusivu"><img src="/images/lupava-logo.png" alt="" width="40" height="40"/><b>Lupava.fi</b></a>;
}

type SiteHeaderProps = {
  signedIn?: boolean;
  loginLabel?: string;
  onLogout?: () => void;
  workspaceUserLabel?: string | undefined;
  workspace?: boolean;
};

const navigation = [
  ["Etusivu", "/#top"],
  ["Kartta", "/#map"],
  ["Luvat", "/#permits"],
  ["Säännöt", "/#how"],
  ["Alueet", "/alueet"],
  ["Ohjeet", "/#help"],
  ["Organisaatioille", "/organisaatioille"],
] as const;

export function SiteHeader({ signedIn = false, loginLabel = "Kirjaudu", onLogout, workspaceUserLabel, workspace = false }: SiteHeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const activeHref = window.location.pathname.startsWith("/organisaatio") ? "/organisaatioille" : window.location.pathname.startsWith("/alue") ? "/alueet" : window.location.pathname === "/" ? "/#top" : "";
  return <header className={`site-header${workspace ? " workspace-site-header" : ""}`}>
    <SiteBrand/>
    <button className="menu-toggle" onClick={() => setMenuOpen(value => !value)} aria-expanded={menuOpen} aria-controls="main-navigation" aria-label={menuOpen ? "Sulje valikko" : "Avaa valikko"}>{menuOpen ? <X/> : <Menu/>}</button>
    <nav id="main-navigation" className={menuOpen ? "open" : ""} aria-label="Päänavigaatio">{navigation.map(([label, href]) => <a href={href} key={label} aria-current={href === activeHref ? "page" : undefined} onClick={() => setMenuOpen(false)}>{label}</a>)}</nav>
    {signedIn && onLogout && workspaceUserLabel ? <div className="workspace-header-tools"><button aria-label="Ilmoitukset"><Bell/></button><button aria-label="Ohje"><CircleHelp/></button><button className="workspace-profile" onClick={onLogout} title="Kirjaudu ulos"><span><UserRound/></span><b>{workspaceUserLabel}</b><ChevronDown/></button></div> : signedIn && onLogout ? <button className="account-logout shared-header-action" onClick={onLogout}><LogOut size={17}/> Kirjaudu ulos</button> : loginLabel === "Oma sivu" ? <a className="header-help" href="/oma"><UserRound size={18}/> Oma sivu</a> : <a className="account-login-link shared-header-action" href="/kirjaudu"><LogIn size={17}/> {loginLabel}</a>}
  </header>;
}

export function SiteFooter() {
  return <footer className="site-footer">
    <div><SiteBrand/><p>Luotettavaa kalastusneuvontaa julkaistun ja lähteistetyn tiedon perusteella.</p></div>
    <div><b>Palvelu</b><a href="/#top">Selvitä lupa</a><a href="/#map">Kartta</a><a href="/#permits">Lupatuotteet</a><a href="/oma">Oma sivu</a></div>
    <div><b>Tietoa</b><a href="/alueet">Aluehakemisto</a><a href="/#directories">Alueet ja toimijat</a><a href="/organisaatioille">Organisaatioille</a><a href="/#how">Miten palvelu toimii</a><a href="/#help">Ohjeet</a></div>
    <div className="footer-boundary"><ShieldCheck size={20}/><span><b>Natural Core</b><p>Luonnoksia tai tarkastamattomia AI-ehdotuksia ei julkaista.</p></span></div>
    <small>© 2026 Lupava.fi · Tietosuojaseloste · Saavutettavuusseloste</small>
  </footer>;
}
